'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _IconButton = require('../../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var classList = this.compileStyle(_index2.default),
        list = null,
        icon = void 0;

    icon = this.props.icon || _react2.default.createElement(
        _IconButton2.default,
        null,
        _react2.default.createElement('div', { className: classList.buttonImg })
    );

    if (this.state.active) {
        list = _react2.default.Children.map(this.props.children, function (child, i) {
            if (child) {
                return _react2.default.createElement(
                    'div',
                    {
                        className: classList.item,
                        key: i,
                        onClick: _this._handleItemClick,
                        onKeyDown: _this._handleItemKeyDown
                    },
                    child
                );
            }
        });

        list = _react2.default.createElement(
            'div',
            { className: classList.list },
            list
        );
    }

    return _react2.default.createElement(
        'div',
        {
            className: classList.root + ' ' + (this.props.className || ''),
            ref: this._rootRef
        },
        _react2.default.createElement(_reactEventListener2.default, {
            target: window.document.querySelector('body'),
            onClick: this._handleBodyClick
        }),
        _react2.default.createElement(
            'div',
            {
                className: classList.button,
                onClick: this._handleClick,
                onMouseEnter: this._handleMouseEnter,
                onMouseLeave: this._handleMouseLeave
            },
            icon
        ),
        list
    );
}